import Vue from '@/setup'
import { v4 as uuidv4 } from 'uuid'

import { SessionUtil } from '@/utils/Session'

import { BasketHelper } from '@/helpers/Basket'
import { CollectiveHelper } from '@/helpers/Collective'
import { ContractHelper } from '@/helpers/Contract'
import { DistributionHelper } from '@/helpers/Distribution'
import { CHANNEL_OVP, DEFAULT_DISTRIBUTION_PARTNER_NUMBER } from '@/config/constants'
const { $backend, $session } = Vue.prototype

function $_getBasket({ basketId, jwToken }) {
  return $backend.ovp
    .getBasket({ basketId, jwToken })
    .then(basket => BasketHelper.updateBasketSession(basket))
    .catch(error => Promise.reject(error))
}

function $_restoreSession(basket) {
  return BasketHelper.setLanguage(basket)
    .then(basket => CollectiveHelper.loadCollective(basket))
    .then(basket => BasketHelper.getAndSetProducts(basket))
    .then(basket => BasketHelper.getAndSetDistributionPartnerByBasket(basket))
    .then(basket => ContractHelper.loadContract(basket))
    .catch(error => Promise.reject(error))
}

function $_resume(payload) {
  const getBasket = basket => $_getBasket(basket)
  return $session.resume(getBasket, payload).then(basket => $_restoreSession(basket))
}

function $_createBasketAndStartSession(payload, local = false) {
  // all other cases: create basket locally
  if (local) {
    const basketId = uuidv4()

    const initialBasket = {
      basketId,
      distributionPartners: DistributionHelper.createDistributionPartners(DEFAULT_DISTRIBUTION_PARTNER_NUMBER),
      persons: [],
      channel: payload.channel || CHANNEL_OVP,
      ...payload,
    }

    return $session
      .start(() => Promise.resolve(initialBasket), payload)
      .then(basket => BasketHelper.updateBasketSession(basket))
      .then(basket => BasketHelper.setLanguage(basket))

    // if collective/partner is active, post to backend immediatly
  } else {
    return $session
      .start(basket => $backend.ovp.createBasket(basket), payload)
      .then(basket => BasketHelper.updateBasketSession(basket))
      .then(basket => $_restoreSession(basket))
  }
}

export const SessionHelper = {
  ...SessionUtil,

  restore(basket) {
    return $_restoreSession(basket)
  },

  resume(payload) {
    return $_resume(payload)
  },

  autostart(payload, options = {}) {
    if (!payload.language) throw new Error('language missing')

    const freshStart = !options.startNewSession
    if (options.startNewSession) {
      return $_createBasketAndStartSession(payload, freshStart)
    } else {
      return SessionHelper.resume().catch(() => $_createBasketAndStartSession(payload, freshStart))
    }
  },
}
